// Privacy Notice Overlay Handler
// Shows privacy notice on first visit, respects rotate overlay priority

const PRIVACY_ACCEPTED_KEY = 'gifsig_privacy_accepted';

function initPrivacyNotice() {
    const privacyOverlay = document.getElementById('privacyOverlay');
    const termsModal = document.getElementById('termsModal');
    const acceptPrivacyBtn = document.getElementById('acceptPrivacyBtn');
    const viewTermsBtn = document.getElementById('viewTermsBtn');
    const closeTermsBtn = document.getElementById('closeTermsBtn');
    const closeTermsFooterBtn = document.getElementById('closeTermsFooterBtn');
    const rotateOverlay = document.getElementById('rotateOverlay');

    if (!privacyOverlay || !termsModal) {
        console.warn('Privacy notice elements not found');
        return;
    }

    // Check if user has already accepted privacy notice
    function hasAcceptedPrivacy() {
        return localStorage.getItem(PRIVACY_ACCEPTED_KEY) === 'true';
    }

    // Show privacy overlay if not accepted and rotate overlay is not visible
    function checkAndShowPrivacy() {
        if (hasAcceptedPrivacy()) {
            return;
        }

        // Check if rotate overlay is visible (portrait mode on mobile)
        const isRotateOverlayVisible = rotateOverlay && 
            window.getComputedStyle(rotateOverlay).display !== 'none';

        // Only show privacy overlay if rotate overlay is not showing
        if (!isRotateOverlayVisible) {
            setTimeout(() => {
                privacyOverlay.classList.add('active');
            }, 500); // Small delay for smoother UX after page load
        }
    }

    // Handle accepting privacy notice
    function acceptPrivacy() {
        localStorage.setItem(PRIVACY_ACCEPTED_KEY, 'true');
        privacyOverlay.classList.remove('active');
    }

    // Show terms modal
    function showTerms() {
        termsModal.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    // Hide terms modal
    function hideTerms() {
        termsModal.classList.remove('active');
        document.body.style.overflow = '';
    }

    // Event listeners
    if (acceptPrivacyBtn) {
        acceptPrivacyBtn.addEventListener('click', acceptPrivacy);
    }

    if (viewTermsBtn) {
        viewTermsBtn.addEventListener('click', showTerms);
    }

    if (closeTermsBtn) {
        closeTermsBtn.addEventListener('click', hideTerms);
    }

    if (closeTermsFooterBtn) {
        closeTermsFooterBtn.addEventListener('click', hideTerms);
    }

    // Close terms modal when clicking outside
    if (termsModal) {
        termsModal.addEventListener('click', (e) => {
            if (e.target === termsModal) {
                hideTerms();
            }
        });
    }

    // Listen for orientation changes on mobile
    // Re-check privacy overlay visibility when rotating
    if (window.matchMedia) {
        window.matchMedia('(orientation: portrait)').addEventListener('change', (e) => {
            // When rotating from portrait to landscape, show privacy if needed
            if (!e.matches && !hasAcceptedPrivacy()) {
                setTimeout(checkAndShowPrivacy, 100);
            } else if (e.matches) {
                // When rotating to portrait, hide privacy (rotate overlay takes priority)
                privacyOverlay.classList.remove('active');
            }
        });
    }

    // Initial check
    checkAndShowPrivacy();

    // Also expose a global function for manual triggering (e.g., from settings)
    window.showPrivacyNotice = function() {
        privacyOverlay.classList.add('active');
    };

    window.showTermsAndPrivacy = function() {
        showTerms();
    };
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrivacyNotice);
} else {
    initPrivacyNotice();
}

export { initPrivacyNotice };
